export default __webpack_public_path__ + "static/media/incompatibility-icon-blend.af0d5f21.svg";